import React, { Component } from 'react';

class Footer extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div className="row top-separator-xs">
                
            </div>
        );
    }

};
export default Footer;